import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 165,
	height: 44,
	viewBox: "0 0 165 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_780_7949)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M43.9113 21.8287C43.9113 34.0122 34.3295 43.594 21.9556 43.594C9.5818 43.594 0 34.0122 0 21.8287C0 9.64525 9.5818 0 21.9556 0C34.3295 0 43.9113 9.64525 43.9113 21.8287ZM40.9923 21.8287C40.9923 10.9778 32.87 2.53822 21.9556 2.53822C11.0413 2.53822 2.91896 10.9778 2.91896 21.8287C2.91896 32.6796 11.0413 41.0558 21.9556 41.0558C32.87 41.0558 40.9923 32.6162 40.9923 21.8287Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.686 10.1212H8.50317V14.304H12.686V10.1212Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.2348 13.294H20.052V17.4767H24.2348V13.294Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.1432 10.0842H31.9604V14.2669H36.1432V10.0842Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.0546 24.5256H29.8718V28.7084H34.0546V24.5256Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.0644 34.2184H12.8816V38.4012H17.0644V34.2184Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.3135 13.6364L11.8584 13.9058L17.633 23.6623L18.0881 23.393L12.3135 13.6364Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.6977 17.3071L20.5869 23.6782L21.1079 23.769L22.2186 17.3979L21.6977 17.3071Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.3606 13.5954L22.8438 23.7511L23.2296 24.1127L32.7465 13.957L32.3606 13.5954Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.0038 26.3499H23.1348V26.8787H30.0038V26.3499Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.8247 28.5441L15.0244 35.1609L15.483 35.4243L19.2832 28.8074L18.8247 28.5441Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.1401 23.2036H16.8157V29.528H23.1401V23.2036Z",
					fill: "#EE1C24"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_780_7949)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M72.3626 7.95164H61.9133V19.1407H72.0852V20.9901H61.9133V36.9415H59.8789V6.10221H72.3626V7.95164Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M107.548 21.9303C107.548 30.8075 100.566 37.7892 91.5503 37.7892C82.5343 37.7892 75.5527 30.8075 75.5527 21.9303C75.5527 13.053 82.5343 6.02515 91.5503 6.02515C100.566 6.02515 107.548 13.053 107.548 21.9303ZM105.421 21.9303C105.421 14.0239 99.5029 7.87458 91.5503 7.87458C83.5978 7.87458 77.6796 14.0239 77.6796 21.9303C77.6796 29.8366 83.5978 35.9397 91.5503 35.9397C99.5029 35.9397 105.421 29.7904 105.421 21.9303Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M111.008 37.0956V5.93267L136.9 33.0269V6.25633H138.934V37.8816L113.042 10.7874V37.0956H111.008Z",
					fill: "black",
					fillOpacity: .8
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M143.088 37.3268V6.4875H149.191C151.919 6.4875 156.681 6.90363 160.565 10.7874C163.848 14.0702 165.004 18.5551 165.004 21.9303C165.004 25.3055 163.848 29.7441 160.565 33.0269C156.681 36.9107 151.919 37.3268 149.191 37.3268H143.088ZM145.122 35.4774H149.145C157.282 35.4774 162.877 29.9291 162.877 21.9303C162.877 13.9315 157.236 8.33694 149.145 8.33694H145.122V35.4774Z",
					fill: "black",
					fillOpacity: .8
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_780_7949",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 43.9113,
				height: 43.594,
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_780_7949",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 105.121,
				height: 31.9489,
				fill: "white",
				transform: "translate(59.8789 5.93267)"
			})
		})] })
	]
});
export default SvgLogo;
